import permissionsApi from 'Api/axios/permissions-api';
import { useEffect, useState } from 'react';
import { PermissionI } from 'types';

interface Props {
  init?: boolean;
}

const usePermissionsApi = ({ init = false }: Props = {}) => {
  /**
   * Variable para almacenar todos los permisos disponibles en la
   * base de datos del sistema.
   */
  const [data, setData] = useState<PermissionI[]>();

  /**
   * Variable para almacenar el estado de carga de los datos.
   */
  const [loading, setLoading] = useState(false);

  /**
   * Variable para almacenar el estado de un error.
   */
  const [error, setError] = useState<string | null>(null);

  /**
   * Realiza una petición para obtener todos los permisos disponibles en el sistema.
   */
  const fetchPermissions = async () => {
    setLoading(true);
    const response = await permissionsApi.readAll();
    setData(response.data ?? []);
    setLoading(false);
    setError(response.error);
  };

  /**
   * Permite obtener los permisos al inicializar el hook.
   */
  useEffect(() => {
    if (init) {
      fetchPermissions();
    }
  }, [init]);

  return {
    data,
    loading,
    error,
    fetchPermissions,
  };
};

export default usePermissionsApi;